import React from 'react';
import BannerAnim from 'rc-banner-anim';
import styles from './index.css';
import env from '../../lib/env';

const { Element, Arrow, Thumb } = BannerAnim;
const BgElement = Element.BgElement;

const bookArray = [
	//兽语觉醒
	// {
	// 	novel_id: "128686",
	// 	pic: "https://img.cgwrite.cn/novel/cover/2509/198286.png"
	// },
	//神明复苏
	{
		novel_id: "128687",
		pic: "https://img.cgwrite.cn/novel/cover/2509/665725.png"
	},
	//刚满十八
	// {
	// 	novel_id: "128689",
	// 	pic: "https://img.cgwrite.cn/novel/cover/2509/068539.png"
	// },
]

export default class BigBanner extends React.Component {

	state = {
		cur_idx: 0,
	}

	banner = null;

	change = (type, cur_idx) => {
		if (type === 'before') {
			this.setState({ cur_idx });
		}
	};

	jump = idx => {
		if (this.banner) {
			this.banner.slickGoTo(idx);
		}
	}

	render() {
		//const bodyW = document.querySelector('body').offsetWidth;
		const thumbChildren = bookArray.map((img, i) =>
			<span key={i} className={this.state.cur_idx === i ? styles.thumb_active : ''}></span>
		);
		return (
			<div>
				<div style={{ position: 'relative' }}>
					<BannerAnim
						prefixCls={styles.anim_body}
						// style={{ height: bodyW * 466 / 1400 + 'px', width: '1000px', margin: '0 auto' }}
						style={{ height: '500px', width: '1000px', margin: '0 auto' }}
						autoPlay
						autoPlaySpeed={5000}
						onChange={this.change}
					>
						{bookArray.map((item, idx) => (
							<Element
								onClick={() => env.goto_page(`/book/detail/${item.novel_id}`)}
								key={idx} prefixCls={styles.anim_element}>
								<BgElement
									key="bg"
									className={styles.bg}
									style={{
										backgroundImage: `url(${item.pic})`,
										backgroundSize: 'cover',
										backgroundPosition: 'center',
										cursor: 'pointer',
									}}
								/>
							</Element>
						))}
						<Arrow arrowType={"prev"} key={"prev"} prefixCls={styles.userArrowPrev}></Arrow>
						<Arrow arrowType={"next"} key={"next"} prefixCls={styles.userArrowNext}></Arrow>
						<Thumb key={"thumb"} prefixCls={styles.userthumb}>
							{thumbChildren}
						</Thumb>
					</BannerAnim>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/component/big_banner/index.js